/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
 (function () {
   // Watch for .bold_options being added to the DOM so it can be moved
   var observer = new MutationObserver(function (mutations) {
     mutations.forEach(function (mutation) {
       mutation.addedNodes.forEach(function (node) {
         if (
           node.nodeType === 1 && // Element node
           node.classList.contains("bold_options")
         ) {

            $(".product__controls-group-quantity").insertAfter($("#customily-options"));
            $(".bold_options").insertBefore($(".product__block--buttons"));

           // only run observer once
           observer.disconnect();
         }
       });
     });
   });

   observer.observe(document.body, { childList: true, subtree: true });
 })();




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
